import { Component, OnDestroy, OnInit, ViewEncapsulation, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { CompanyService } from '@fuse/services/company.service';
import * as _ from 'lodash';

import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { AuthService } from '@fuse/services/auth/auth.service';

import { navigation } from 'app/navigation/navigation';
import { Router } from '@angular/router';
import { User } from '@fuse/types/user';
import { ProfileService } from '@fuse/services/profile.service';
import { FuseUploadService } from '@fuse/components/upload/upload.service';

@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy {
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    hiddenToolbar: boolean;
    companies: any;
    activeCompany: any;
    languages: any;
    langs: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];
    userInfo: User;
    profileImage: any;
    lang = 'sr';
    loggedIn = false;
    companyId = this._companyService.activeCompany.id;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {CompanyService} _companyService
     * @param {TranslateService} _translateService
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private _translateService: TranslateService,
        private _translationLoader: FuseTranslationLoaderService,
        private _companyService: CompanyService,
        private _authService: AuthService,
        private _router: Router,
        private _profileService: ProfileService,
        private _uploadService: FuseUploadService
    ) {
        // Set the defaults
        this.userStatusOptions = [
            {
                title: 'Online',
                icon: 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Away',
                icon: 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'Do not Disturb',
                icon: 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Invisible',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD'
            },
            {
                title: 'Offline',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];

        this.languages = [
            {
                id: 'en',
                title: 'English',
                flag: 'en'
            }
        ];

        this.selectedLanguage = { id: 'sr', title: 'Serbian', flag: 'sr' };

        this.userInfo = {
            id: null,
            title: '',
            email: '',
            first_name: '',
            last_name: '',
            created_at: null,
            updated_at: null,
            deleted_at: null
        };

        this.companies = [
            {
                id: 1,
                name: 'Google',
                chat_token: ''
            }
        ];

        this.activeCompany = 'Google';

        this.navigation = navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }


    loadScript(chatToken): void {
        if (chatToken && chatToken !== '') {
            console.log(chatToken);
            const node = document.createElement('script');
            node.src = 'https://www.socialintents.com/api/socialintents.1.3.js#' + chatToken;
            console.log(node.src);
            node.async = true;
            node.id = 'chat';
            document.getElementsByTagName('head')[0].appendChild(node);
        }
    }

    loadCompanies(): void {
        this._companyService.getActiveCompany()
            .then(response => {
                this.activeCompany = response;
                this._companyService.setActiveCompany(this.activeCompany);
                console.log(this.activeCompany);
                this.loadScript(this.activeCompany.chat_token);
            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });
        this._companyService.getCompanies()
            .then(response => {

                const temp = [];
                response.data.forEach((company) => {
                    const item = {
                        id: company.id,
                        name: company.name,
                        chat_token: company.chat_token
                    };
                    temp.push(item);
                });

                this.companies = temp;
                // this.activeCompany = {
                //     id: response.data[0].id,
                //     name: response.data[0].name
                // };
                // this._companyService.setActiveCompany(this.activeCompany);
                console.log(this.companies);

            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                this.horizontalNavbar = settings.theme.layout.navbar.position === 'top';
                this.rightNavbar = settings.theme.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.theme.layout.navbar.hidden === true;
                this.hiddenToolbar = settings.theme.layout.toolbar.hidden;

                if (!this._authService.isAuthenticated() && !this.hiddenToolbar) {
                    this.loggedIn = false;
                    this._router.navigate(['/login']);
                } else {

                    if (this._authService.isAuthenticated()) {
                        const user = this._authService.getUser();
                        if (!user) {
                            this._authService.userSetComplete
                                .pipe(takeUntil(this._unsubscribeAll))
                                .subscribe(
                                    response => {
                                        this.userInfo = this._authService.getUser();
                                        this.getMemberProfileImage();
                                    },
                                    err => console.log('error:', err));
                            this._authService.setUser();
                        } else {
                            this.userInfo = user;
                            this.getMemberProfileImage();
                        }
                        this.loggedIn = true;

                        this.loadCompanies();
                    }

                }
            });

        this._authService.logoutComplete
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response) => {
                this.loggedIn = false;
                this.userInfo = this._authService.getUser();
                this.profileImage = null;
            });

        this._uploadService.onFileUploaded
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(response => {
                console.log(response);
                if (response.collection === 'profile') {
                    console.log('Get new profile image.');
                    this.getMemberProfileImage();
                }

            }, err => {

            });

        this._profileService.onProfileChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(response => {
                if (response.collection === 'profile') {
                    console.log('Get new profile image.');
                    this.getMemberProfileImage();
                }

                this._authService.userInfo = null;
                this._authService.setUser();

            }, err => {

            });

        this._translationLoader.getLastLang()
            .then(response => {
                const setLang = { id: response['code'], title: response['name'], flag: response['code'] };
                this.setLanguage(setLang);
                this._translateService.use(response['code']);
            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });

        this._translationLoader.getLanguages()
            .then(response => {
                this.langs = response;
                const temp = [];
                this.langs.forEach((lang) => {
                    const item = {
                        id: lang.code,
                        title: lang.name,
                        flag: lang.code
                    };
                    temp.push(item);
                });
                this.languages = temp;
            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });

        // Set the selected language from default languages


        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this.getTranslations();
            });
        this.getTranslations();

        // this._companyService.onCompanyChanged
        //     .pipe(takeUntil(this._unsubscribeAll))
        //     .subscribe((response) => {
        //         if (this.activeCompany.id !== this._companyService.activeCompany.id ? this._companyService.activeCompany.id : response.id) {
        //             console.log('here');
        //             this.activeCompany.id = this._companyService.activeCompany.id;

        //         }
        //     });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    private createImageFromBlob(image: Blob): void {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            this.profileImage = reader.result;
        }, false);

        if (image) {
            reader.readAsDataURL(image);
        }
    }

    private getTranslations(): void {
        this._translationLoader.getLastLang()
            .then(response => {
                this.lang = response['code'];
                this._translationLoader.getTranslations(this.lang, '9');
            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });
    }

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    /**
     * Search
     *
     * @param value
     */
    search(value): void {
        // Do your search here...
        console.log(value);
    }

    /**
     * Set the language
     *
     * @param lang
     */
    setLanguage(lang): void {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;
        this._translationLoader.setLastLang(lang);

        // Use the selected language for translations
    }

    setActiveCompany(company): void {
        this.activeCompany = company;
        this._companyService.setActiveCompany(company);
        if (document.getElementById('social-intents-tab-chat') !== null) {
            document.getElementById('social-intents-tab-chat').remove();
        }
        if (document.getElementById('siWidget-chat') !== null) {
            document.getElementById('siWidget-chat').remove();
        }
        if (document.getElementById('sibutton') !== null) {
            document.getElementById('sibutton').remove();
        }
        if (document.getElementById('socialintents-chat') !== null) {
            document.getElementById('socialintents-chat').remove();
        }
        if (document.getElementById('chat') !== null) {
            document.getElementById('chat').remove();
        }
        this.loadScript(this.activeCompany.chat_token);
    }

    getMemberProfileImage(): void {
        this._profileService.getMemberProfileImage()
            .then(response => {
                this.createImageFromBlob(response);
            });
    }

    logout(): void {
        this._authService.logout();
        this._router.navigate(['/login']);
    }
}
